import { brand } from "shared-lib/helpers/envFunctions";
import { getIso8601String } from "shared-lib/helpers/utilityFunctions";

import { getRecipeImageURL } from "./helpers/backendFunctions";
import getPlaintextDescription from "./helpers/getPlainTextDescription";

// this regex is used to extract the affiliate link from the string
// the format is "any text before link{affiliate code}[link text](link href)after text after link"
export const affiliateRegex = /(.*)\{([^}]+)\}\[([^\]]+)\]\(([^)]+)\)(.*)/;
function extractAffiliateLink(str: string) {
  const match = str.match(affiliateRegex);

  if (match) {
    // match[1] is everything before {} , match[2] is the group in {}, match[3] is the group in [] and match[4] is the group in ()
    // match[5] is everything after ()

    // return everything before {} + group in {} + everything after ()
    return `${match[1]}${match[2]}${match[5]}`;
  } else {
    return str;
  }
}

export const getChicorySchema = (recipe: Recipe | undefined): string => {
  let structuredData = {};
  if (recipe) {
    // const { fields, sys } = recipe as Recipe;
    structuredData = {
      "@context": "https://schema.org/",
      "@type": "Recipe",
      name: recipe.title,
      image: [getRecipeImageURL(recipe, 400, 300)],
      author: {
        "@type": "Person",
        name: brand.name,
      },
      datePublished: recipe.sys.publishedAt,
      description: getPlaintextDescription(recipe),
      prepTime: getIso8601String(recipe.time ?? ""),
      cookTime: getIso8601String(recipe.time ?? ""),
      totalTime: getIso8601String(recipe.time ?? ""),
      recipeYield: isNaN(parseInt(recipe.yield ?? ""))
        ? recipe.yield
        : parseInt(recipe.yield ?? ""),
      recipeCategory: recipe.category?.name,
      recipeCuisine: "",
      keywords: recipe.tags?.items.map((tag) => tag.name).join(", "),
      nutrition: {
        "@type": "NutritionInformation",
        calories: "",
      },
      recipeIngredient: recipe.ingredients?.map((i) =>
        extractAffiliateLink(i.value),
      ),
      recipeInstructions: recipe.directions?.map((d) => d.value),
      video: [],
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "5",
        ratingCount: "1",
      },
      review: {
        "@type": "Review",
        reviewRating: {
          "@type": "Rating",
          ratingValue: "5",
          bestRating: "1",
        },
        author: {
          "@type": "Person",
          name: brand.name,
        },
        publisher: brand.name,
        reviewBody: `This ${recipe.title} is delicious!`,
        datePublished: recipe.sys.publishedAt,
      },
    };
  }
  return JSON.stringify(structuredData);
};
